import axiosInstance from "../../api/axiosInstance";

export const fetchTablePlayersByIdAPI = async ({ tableId, tournamentId }) => {
  const tablePlayers = await axiosInstance.get(
    `tables/find-all-entries-in-table-v2/${tableId}/${tournamentId}`
  );

  return tablePlayers.data;
};

export const fetchTournamentEntriesByTableIdsAPI = async ({
  tournamentId,
  tableIds = [],
}) => {
  const response = await axiosInstance.get(
    `tables/find-all-entries-in-tournament-v2/${tournamentId}`,
    {
      params: {
        tableIds: tableIds.join(","),
      },
    },
  );

  return response.data;
};

export const movePlayersAPI = async ({ entryMoves, toTableId }) => {
  const response = await axiosInstance.post(
    "players/move-entries-between-tables-v2",
    {
      entryMoves,
      toTableId,
    }
  );

  return response.data;
};

export const moveEntryToNextStageAPI = async ({
  tournamentId,
  fromTableId,
  kind = "user",
  userId = null,
  squadId = null,
}) => {
  const response = await axiosInstance.post("players/move-entry-to-next-stage-v2", {
    tournamentId,
    fromTableId,
    kind,
    userId,
    squadId,
  });

  return response.data;
};

export const moveEntryToFinalStageAPI = async ({
  tournamentId,
  fromTableId,
  kind = "user",
  userId = null,
  squadId = null,
}) => {
  const response = await axiosInstance.post("players/move-entry-to-final-stage-v2", {
    tournamentId,
    fromTableId,
    kind,
    userId,
    squadId,
  });

  return response.data;
};

export const deletePlayerFromTableAPI = async ({
  tournamentId,
  tableId,
  kind = "user",
  userId = null,
  squadId = null,
}) => {
  const response = await axiosInstance.delete(
    "players/delete-entry-from-tournament-v2",
    {
      data: { tournamentId, tableId, kind, userId, squadId },
    },
  );
  return response.data;
};

export const addPlayerToTournamentAPI = async ({
  tournamentId,
  tableId,
  kind = "user",
  userId = null,
  squadId = null,
}) => {
  const response = await axiosInstance.post(
    "players/add-entry-to-tournament-v2",
    { tournamentId, tableId, kind, userId, squadId }
  );

  return response.data;
};

export const setTournamentEntryCheckedAPI = async ({
  tournamentId,
  tableId,
  kind = "user",
  userId = null,
  squadId = null,
  isChecked = false,
}) => {
  const response = await axiosInstance.patch("players/set-entry-checked-v2", {
    tournamentId,
    tableId,
    kind,
    userId,
    squadId,
    isChecked,
  });

  return response.data;
};
